import { AutomatedProProbeSetScale, Hapten, HcrAmplifier, LiquidVolume, MicroliterVolume, Pmol, PredefinedLabel, ProProbeDiluentScale, } from "./kit/automated-pro/RnaCatalog";
import { AutomatedGoldIfKit, AutomatedGoldIfKitPrice, AutomatedGoldIfPricedKit, AutomatedIfAmpLabelPair, AutomatedIfDetectComponent, AutomatedIfEncoderAmpPair, AutomatedIfEncoderComponent, AutomatedProKit, AutomatedProKitPrice, AutomatedProMiscComponent, AutomatedProPricedKit, AutomatedProProbeSetComponent, ChromogenBufferScale, ChromogenComponent, ChromogenScale, CustomTarget, DetectAntiHaptenScale, DetectAScale, DetectBScale, DetectCScale, DetectEnzymeApScale, DetectEnzymeHrpScale, DetectHrpQuencherScale, DetectTyramideHaptenScale, FreeTextAmpLabel, ManualAmplifierComponent, ManualGoldIfKit, ManualGoldIfKitPrice, ManualGoldIfPricedKit, ManualProBuffersComponent, ManualProKit, ManualProPrice, PostProcessAScale, PostProcessBScale, PretreatAScale, PretreatBScale, PretreatScale, PricedManualProKit, ProbeSetScale, ProDetectChannel, ProDetectComponent, ProHematoxylinScale, ProPreHybridizationScale, RnaFishBuffersComponent, RnaFishKit, RnaFishKitPrice, RnaFishPricedKit, SecondaryIfKit, SecondaryIfKitPrice, SecondaryIfPricedKit, SimpleCatalogVariantProbeSet, SimpleLibraryOrganism, SimpleLibraryOrganismCustomTargetProbeSet, SimpleOtherOrganism, SimpleOtherOrganismCustomTargetProbeSet, SimpleProbeSetComponent, SimpleProbeSetFamily, SimpleVariant, } from "./kit/rna-fish/KitModel";
import { EncoderScale, Ugram } from "./kit/secondary-if/SecondaryIfCatalog";
var KitDeserializer = /** @class */ (function () {
    function KitDeserializer() {
    }
    KitDeserializer.deserializeProbeSet = function (psc) {
        var probeSet;
        if (isCatalogEntryProbeSet(psc.probeSet)) {
            var organism = new SimpleLibraryOrganism(psc.probeSet.organism.id, psc.probeSet.organism.name, psc.probeSet.organism.scientificName);
            var psf = new SimpleProbeSetFamily(psc.probeSet.probeSetFamily.id, psc.probeSet.probeSetFamily.geneSymbol, psc.probeSet.probeSetFamily.description, psc.probeSet.probeSetFamily.accessions);
            var variant = new SimpleVariant(psc.probeSet.variant.id, psc.probeSet.variant.name, psc.probeSet.variant.designNumber, psc.probeSet.variant.targetMrnaSeq, psc.probeSet.variant.probeSetSize, psc.probeSet.variant.dcvScore, psc.probeSet.variant.accession);
            var hcrAmplifier = new HcrAmplifier(psc.probeSet.hcrAmplifier.id);
            probeSet = new SimpleCatalogVariantProbeSet(psc.probeSet.customerOrganismName, psc.probeSet.customerTargetName, psc.probeSet.customerAccessionNum, psc.probeSet.customerSequence, psc.probeSet.customerProbeSetSize, organism, psf, variant, hcrAmplifier, psc.probeSet.probeLotNumber);
        }
        else if (isLibraryOrganismProbeSet(psc.probeSet)) {
            var organism = new SimpleLibraryOrganism(psc.probeSet.organism.id, psc.probeSet.organism.name, psc.probeSet.organism.scientificName);
            var customTarget = new CustomTarget(psc.probeSet.target.name, psc.probeSet.target.accession, psc.probeSet.target.targetMrnaSeq);
            var hcrAmplifier = new HcrAmplifier(psc.probeSet.hcrAmplifier.id);
            probeSet = new SimpleLibraryOrganismCustomTargetProbeSet(organism, customTarget, hcrAmplifier, psc.probeSet.probeSetSize, psc.probeSet.probeLotNumber);
        }
        else {
            // must be other organism
            var organism = new SimpleOtherOrganism(psc.probeSet.organism.name);
            var customTarget = new CustomTarget(psc.probeSet.target.name, psc.probeSet.target.accession, psc.probeSet.target.targetMrnaSeq);
            var hcrAmplifier = new HcrAmplifier(psc.probeSet.hcrAmplifier.id);
            probeSet = new SimpleOtherOrganismCustomTargetProbeSet(organism, customTarget, hcrAmplifier, psc.probeSet.probeSetSize, psc.probeSet.probeLotNumber);
        }
        return new SimpleProbeSetComponent(probeSet, new ProbeSetScale(psc.scale.scaleValue, psc.scale.pmol), psc.channel);
    };
    KitDeserializer.deserializeAmplifier = function (amplifier) {
        var label;
        if (isJsonAmplifierCatalogLabel(amplifier.label)) {
            label = new PredefinedLabel(amplifier.label.id, amplifier.label.name, amplifier.label.isStandard);
        }
        else {
            label = new FreeTextAmpLabel(amplifier.label.name);
        }
        return new ManualAmplifierComponent(new HcrAmplifier(amplifier.hcrAmplifier.id), new Pmol(amplifier.scalePmol), label);
    };
    KitDeserializer.deserializeProDetectComponent = function (detect) {
        var presetScale = detect.presetScale;
        var pretreatADewax = new PretreatAScale(detect.pretreatADewax);
        var pretreatBAntigenRetrieval = new PretreatBScale(detect.pretreatBAntigenRetrieval);
        var pretreatBloxol = new PretreatScale(detect.pretreatBloxol);
        var detectA = new DetectAScale(detect.detectA);
        var detectB = new DetectBScale(detect.detectB);
        var detectC = new DetectCScale(detect.detectC);
        var postProcessA = new PostProcessAScale(detect.postProcessA);
        var postProcessB = new PostProcessBScale(detect.postProcessB);
        var preHybridizationScale = new ProPreHybridizationScale(detect.preHybridization);
        var channels = detect.channels.map(function (ch) {
            var hcrAmplifier = ch.hcrAmplifier ? new HcrAmplifier(ch.hcrAmplifier.id) : undefined;
            var hapten = ch.hapten ? new Hapten(ch.hapten) : undefined;
            var detectAntiHapten = new DetectAntiHaptenScale(ch.detectAntiHapten);
            var detectTyramide = new DetectTyramideHaptenScale(ch.detectTyramide);
            var detectEnzymeAp = new DetectEnzymeApScale(ch.detectEnzymeAp);
            var detectEnzymeHrp = new DetectEnzymeHrpScale(ch.detectEnzymeHrp);
            var detectHrpQuencher = new DetectHrpQuencherScale(ch.detectHrpQuencher);
            var enzyme = ch.enzyme;
            return new ProDetectChannel(hcrAmplifier, hapten, detectAntiHapten, detectTyramide, detectEnzymeAp, detectEnzymeHrp, detectHrpQuencher, enzyme, ch.channel);
        });
        return new ProDetectComponent(detect.prefilled, presetScale, detect.customScale, pretreatADewax, pretreatBAntigenRetrieval, pretreatBloxol, detectA, detectB, detectC, postProcessA, postProcessB, preHybridizationScale, channels);
    };
    KitDeserializer.deserializeBuffers = function (buffers) {
        return new RnaFishBuffersComponent(new LiquidVolume(buffers.hybridizationBufferMl), new LiquidVolume(buffers.probeWashBufferMl), new LiquidVolume(buffers.ampBufferMl), new LiquidVolume(buffers.ampWashBufferMl));
    };
    KitDeserializer.deserializeAutomatedProMiscComponent = function (misc) {
        return new AutomatedProMiscComponent(misc.description, misc.scaleInMl, misc.scaleInSlides);
    };
    KitDeserializer.deserializeChromogenComponent = function (chromogen) {
        var chromogenScale = new ChromogenScale(new MicroliterVolume(chromogen.chromogenScale.volume));
        var chromogenBufferScale = new ChromogenBufferScale(new MicroliterVolume(chromogen.chromogenBufferScale.volume));
        var hematoxylinScale = new ProHematoxylinScale(new MicroliterVolume(chromogen.hematoxylinScale.volume));
        return new ChromogenComponent(chromogen.presetScale, chromogen.customScale, chromogen.chromogen, chromogen.chromogenBuffer, chromogenScale, chromogenBufferScale, hematoxylinScale);
    };
    KitDeserializer.deserializeAutomatedProProbeSet = function (psc) {
        var probeSet;
        if (isRnaCishCatalogEntryProbeSetResponse(psc.probeSet)) {
            var p = psc.probeSet;
            var organism = new SimpleLibraryOrganism(p.organism.id, p.organism.name, p.organism.scientificName);
            var probeSetFamily = new SimpleProbeSetFamily(p.probeSetFamily.id, p.probeSetFamily.geneSymbol, p.probeSetFamily.description, p.probeSetFamily.accessions);
            var variant = new SimpleVariant(p.variant.id, p.variant.name, p.variant.designNumber, p.variant.targetMrnaSeq, p.variant.probeSetSize, p.variant.dcvScore, p.variant.accession);
            var hcrAmplifier = new HcrAmplifier(p.hcrAmplifier.id);
            probeSet = new SimpleCatalogVariantProbeSet(p.customerOrganismName, p.customerTargetName, p.customerAccessionNum, p.customerSequence, p.customerProbeSetSize, organism, probeSetFamily, variant, hcrAmplifier, p.probeLotNumber);
        }
        else if (isRnaCishLibraryOrganismCustomTargetResponse(psc.probeSet)) {
            var p = psc.probeSet;
            var organism = new SimpleLibraryOrganism(p.organism.id, p.organism.name, p.organism.scientificName);
            var customTarget = new CustomTarget(p.target.name, p.target.accession, p.target.targetMrnaSeq);
            var hcrAmplifier = new HcrAmplifier(p.hcrAmplifier.id);
            probeSet = new SimpleLibraryOrganismCustomTargetProbeSet(organism, customTarget, hcrAmplifier, p.probeSetSize, p.probeLotNumber);
        }
        else {
            var p = psc.probeSet;
            var organism = new SimpleOtherOrganism(p.organism.name);
            var customTarget = new CustomTarget(p.target.name, p.target.accession, p.target.targetMrnaSeq);
            var hcrAmplifier = new HcrAmplifier(p.hcrAmplifier.id);
            probeSet = new SimpleOtherOrganismCustomTargetProbeSet(organism, customTarget, hcrAmplifier, p.probeSetSize, p.probeLotNumber);
        }
        return new AutomatedProProbeSetComponent(probeSet, psc.presetScale, psc.customScale, new AutomatedProProbeSetScale(psc.scale.pmol, psc.scale.volume, psc.scale.labelA, psc.scale.labelB, psc.scale.detailA, psc.scale.detailB), new ProProbeDiluentScale(psc.probeHybridizationAScale.volume, psc.probeHybridizationAScale.labelA, psc.probeHybridizationAScale.labelB, psc.probeHybridizationAScale.detail), new ProProbeDiluentScale(psc.probeHybridizationBScale.volume, psc.probeHybridizationBScale.labelA, psc.probeHybridizationBScale.labelB, psc.probeHybridizationBScale.detail), psc.channel);
    };
    KitDeserializer.deserialize = function (json) {
        if (isRnaFishKit(json)) {
            var probeSetComponent = void 0;
            var amplifierComponent = void 0;
            var buffersComponent = void 0;
            var kit = json.kit;
            if (kit.probeSetComponent) {
                probeSetComponent = KitDeserializer.deserializeProbeSet(kit.probeSetComponent);
            }
            if (kit.amplifierComponent) {
                amplifierComponent = KitDeserializer.deserializeAmplifier(kit.amplifierComponent);
            }
            if (kit.buffersComponent) {
                buffersComponent = KitDeserializer.deserializeBuffers(kit.buffersComponent);
            }
            if (kit.probeSetComponent === undefined && kit.amplifierComponent === undefined && kit.buffersComponent === undefined) {
                throw new Error("Must have at least one component of a kit");
            }
            return new RnaFishKit(kit.comment, kit.legacy, kit.sampleType, kit.starterKit, probeSetComponent, amplifierComponent, buffersComponent);
        }
        else if (isAutomatedProKit(json)) {
            var kit = json.kit;
            var probeSetComponents = kit.probeSetComponent.map(function (psc) {
                return KitDeserializer.deserializeAutomatedProProbeSet(psc);
            });
            var detectComponent = void 0;
            if (kit.detectComponent) {
                detectComponent = KitDeserializer.deserializeProDetectComponent(kit.detectComponent);
            }
            var chromogenComponent = void 0;
            if (kit.chromogenComponent) {
                var presetScale = kit.chromogenComponent.presetScale;
                var chromogenScale = new ChromogenScale(new MicroliterVolume(kit.chromogenComponent.chromogenScale.volume));
                var chromogenBufferScale = new ChromogenBufferScale(new MicroliterVolume(kit.chromogenComponent.chromogenBufferScale.volume));
                var hematoxylinScale = new ProHematoxylinScale(new MicroliterVolume(kit.chromogenComponent.hematoxylinScale.volume));
                chromogenComponent = new ChromogenComponent(presetScale, kit.chromogenComponent.customScale, kit.chromogenComponent.chromogen, kit.chromogenComponent.chromogenBuffer, chromogenScale, chromogenBufferScale, hematoxylinScale);
            }
            var miscComponent = void 0;
            if (kit.miscComponent) {
                miscComponent = KitDeserializer.deserializeAutomatedProMiscComponent(kit.miscComponent);
            }
            if (probeSetComponents.length === 0 && detectComponent === undefined && chromogenComponent === undefined && miscComponent === undefined) {
                throw new Error("Must have at least one component of a kit");
            }
            return new AutomatedProKit(kit.comment, kit.reasonForOther, kit.protocolType, kit.config, kit.plexity, probeSetComponents, kit.starterKit, detectComponent, miscComponent, chromogenComponent);
        }
        else if (isManualPro(json)) {
            var kit = json.kit;
            var probeSetComponent = void 0;
            if (kit.probeSetComponent) {
                probeSetComponent = KitDeserializer.deserializeProbeSet(kit.probeSetComponent);
            }
            var detectComponent = void 0;
            if (kit.detectComponent) {
                detectComponent = KitDeserializer.deserializeProDetectComponent(kit.detectComponent);
            }
            var buffersComponent = void 0;
            if (kit.buffersComponent) {
                buffersComponent = new ManualProBuffersComponent(kit.buffersComponent.hybridizationBufferMl, kit.buffersComponent.ampWashBufferMl, kit.buffersComponent.probeWashBufferMl);
            }
            var chromogenComponent = void 0;
            if (kit.chromogenComponent) {
                var presetScale = kit.chromogenComponent.presetScale;
                var chromogenScale = new ChromogenScale(new MicroliterVolume(kit.chromogenComponent.chromogenScale.volume));
                var chromogenBufferScale = new ChromogenBufferScale(new MicroliterVolume(kit.chromogenComponent.chromogenBufferScale.volume));
                var hematoxylinScale = new ProHematoxylinScale(new MicroliterVolume(kit.chromogenComponent.hematoxylinScale.volume));
                chromogenComponent = new ChromogenComponent(presetScale, kit.chromogenComponent.customScale, kit.chromogenComponent.chromogen, kit.chromogenComponent.chromogenBuffer, chromogenScale, chromogenBufferScale, hematoxylinScale);
            }
            if (probeSetComponent === undefined && detectComponent === undefined && buffersComponent === undefined && chromogenComponent === undefined) {
                throw new Error("Must have at least one component of a kit");
            }
            return new ManualProKit(kit.sampleType, probeSetComponent, detectComponent, buffersComponent, chromogenComponent, kit.comment, kit.negativeControlProbe, kit.starterKit);
        }
        else if (isSecondaryIfKit(json)) {
            var probeComponent = void 0;
            var amplifierComponent = void 0;
            var buffersComponent = void 0;
            var kit = json.kit;
            if (kit.probeComponent) {
                probeComponent = {
                    probe: kit.probeComponent.probe,
                    amplifier: {
                        id: kit.probeComponent.amplifier.id,
                        amplifier: new HcrAmplifier(kit.probeComponent.amplifier.amplifier.id)
                    },
                    scale: new Ugram(kit.probeComponent.scaleUgram)
                };
            }
            if (kit.amplifierComponent) {
                amplifierComponent = KitDeserializer.deserializeAmplifier(kit.amplifierComponent);
            }
            if (kit.buffersComponent) {
                buffersComponent = {
                    antibodyBuffer: new LiquidVolume(kit.buffersComponent.antibodyBufferMl),
                    antibodyWashBuffer: new LiquidVolume(kit.buffersComponent.antibodyWashBufferMl),
                    amplificationBuffer: new LiquidVolume(kit.buffersComponent.amplificationBufferMl),
                    goldAmpWashBuffer: new LiquidVolume(kit.buffersComponent.goldAmpWashBufferMl)
                };
            }
            return new SecondaryIfKit(json.kit.comment, json.kit.legacy, json.kit.sampleType, kit.starterKit, probeComponent, amplifierComponent, buffersComponent);
        }
        else if (isAutomatedGoldIfKit(json)) {
            var kit = json.kit;
            var encoderComponent = kit.encoderComponent
                ? new AutomatedIfEncoderComponent(kit.encoderComponent.encoderAmpPairs.map(function (p) {
                    return new AutomatedIfEncoderAmpPair(p.primarySpecies, new HcrAmplifier(p.hcrAmplifier.id), p.channel);
                }), kit.encoderComponent.encoderScaleUl, kit.encoderComponent.antibodyBlockMl, kit.encoderComponent.antibodyDiluentMl)
                : undefined;
            var detectComponent = kit.detectComponent
                ? new AutomatedIfDetectComponent(kit.detectComponent.ampLabelPairs.map(function (p) {
                    return new AutomatedIfAmpLabelPair(new HcrAmplifier(p.hcrAmplifier.id), new PredefinedLabel(p.fluorophore.id, p.fluorophore.name, p.fluorophore.isStandard), p.channel);
                }), kit.detectComponent.detectAMl, kit.detectComponent.detectBMl, kit.detectComponent.detectCMl)
                : undefined;
            return new AutomatedGoldIfKit(kit.plexity, kit.sampleType, kit.platform, kit.comment, kit.starterKit, kit.presetScale, encoderComponent, detectComponent);
        }
        else {
            var encoderComponent = void 0;
            var encoderAmplifierComponent = void 0;
            var encoderBuffersComponent = void 0;
            var kit = json.kit;
            if (kit.encoderComponent) {
                encoderComponent = {
                    encodeA: kit.encoderComponent.encodeA,
                    hcrAmplifier: new HcrAmplifier(kit.encoderComponent.hcrAmplifier.id),
                    scale: new EncoderScale(kit.encoderComponent.scale.slides, kit.encoderComponent.scale.samples)
                };
            }
            if (kit.amplifierComponent) {
                encoderAmplifierComponent = KitDeserializer.deserializeAmplifier(kit.amplifierComponent);
            }
            if (kit.buffersComponent) {
                encoderBuffersComponent = {
                    antibodyBuffer: new LiquidVolume(kit.buffersComponent.antibodyBufferMl),
                    antibodyWashBuffer: new LiquidVolume(kit.buffersComponent.antibodyWashBufferMl),
                    amplificationBuffer: new LiquidVolume(kit.buffersComponent.amplificationBufferMl),
                    ampWashBuffer: new LiquidVolume(kit.buffersComponent.ampWashBufferMl)
                };
            }
            return new ManualGoldIfKit(json.kit.comment, json.kit.sampleType, kit.starterKit, encoderComponent, encoderAmplifierComponent, encoderBuffersComponent);
        }
    };
    KitDeserializer.deserializePricedKit = function (json) {
        if (isRnaFishPricedKit(json)) {
            var kit = KitDeserializer.deserialize(json);
            var price = new RnaFishKitPrice(json.price.probeSetPriceCents, json.price.probeSetPriceCustom, json.price.amplifierPriceCents, json.price.amplifierPriceCustom, json.price.buffersPriceCents, json.price.buffersPriceCustom, json.price.subtotalCents);
            return new RnaFishPricedKit(kit, price);
        }
        else if (isAutomatedProPricedKit(json)) {
            var kit = KitDeserializer.deserialize(json);
            var price = new AutomatedProKitPrice(json.price.customPrice, json.price.probeSetPriceCents, json.price.detectPriceCents, json.price.chromogenPriceCents, json.price.miscComponentPriceCents, json.price.subtotalCents);
            return new AutomatedProPricedKit(kit, price);
        }
        else if (isPricedManualPro(json)) {
            var kit = KitDeserializer.deserialize(json);
            var price = new ManualProPrice(json.price.probeSetPriceCents, json.price.probeSetPriceCustom, json.price.detectPriceCents, json.price.detectPriceCustom, json.price.buffersPriceCents, json.price.buffersPriceCustom, json.price.chromogenPriceCents, json.price.chromogenPriceCustom);
            return new PricedManualProKit(kit, price);
        }
        else if (isSecondaryIfPricedKit(json)) {
            var kit = KitDeserializer.deserialize(json);
            var price = new SecondaryIfKitPrice(json.price.probePriceCents, json.price.probePriceCustom, json.price.amplifierPriceCents, json.price.amplifierPriceCustom, json.price.buffersPriceCents, json.price.buffersPriceCustom, json.price.subtotalCents);
            return new SecondaryIfPricedKit(kit, price);
        }
        else if (isAutomatedGoldIfPricedKit(json)) {
            var kit = KitDeserializer.deserialize(json);
            var price = new AutomatedGoldIfKitPrice(json.price.encoderPriceCents, json.price.encoderPriceCustom, json.price.detectPriceCents, json.price.detectPriceCustom, json.price.subtotalCents);
            return new AutomatedGoldIfPricedKit(kit, price);
        }
        else {
            var kit = KitDeserializer.deserialize(json);
            var price = new ManualGoldIfKitPrice(json.price.encoderPriceCents, json.price.encoderPriceCustom, json.price.amplifierPriceCents, json.price.amplifierPriceCustom, json.price.buffersPriceCents, json.price.buffersPriceCustom, json.price.subtotalCents);
            return new ManualGoldIfPricedKit(kit, price);
        }
    };
    return KitDeserializer;
}());
export default KitDeserializer;
var isManualPro = function (b) {
    return b._type === 'manual-pro';
};
var isPricedManualPro = function (b) {
    return b._type === 'manual-pro';
};
var isRnaFishKit = function (b) {
    return b._type === 'rna-fish';
};
var isRnaFishPricedKit = function (b) {
    return b._type === 'rna-fish';
};
var isCatalogEntryProbeSet = function (p) {
    return p._type === 'catalog';
};
var isLibraryOrganismProbeSet = function (p) {
    return p._type === 'libraryOrganismCustomTarget';
};
var isAutomatedProKit = function (b) {
    return b._type === 'rna-cish';
};
var isAutomatedProPricedKit = function (b) {
    return b._type === 'rna-cish';
};
var isRnaCishCatalogEntryProbeSetResponse = function (p) {
    return p._type === 'catalog';
};
var isRnaCishLibraryOrganismCustomTargetResponse = function (p) {
    return p._type === 'libraryOrganismCustomTarget';
};
var isSecondaryIfKit = function (b) {
    return b._type === '2-ihc';
};
var isSecondaryIfPricedKit = function (b) {
    return b._type === '2-ihc';
};
var isAutomatedGoldIfKit = function (b) {
    return b._type === 'automated-gold-if';
};
var isAutomatedGoldIfPricedKit = function (b) {
    return b._type === 'automated-gold-if';
};
var isJsonAmplifierCatalogLabel = function (s) {
    return s._type === 'predefined';
};
export var ProKitConfig;
(function (ProKitConfig) {
    ProKitConfig["ProbeDetect"] = "Probe + Detect";
    ProKitConfig["ProbeOnly"] = "Probe Only";
    ProKitConfig["DetectOnly"] = "Detect Only";
    ProKitConfig["StarterKitProbe"] = "Starter Kit Probe";
    ProKitConfig["Other"] = "Other";
    ProKitConfig["ExtrasOnly"] = "Extras Only";
})(ProKitConfig || (ProKitConfig = {}));
export var Plexity;
(function (Plexity) {
    Plexity[Plexity["OnePlex"] = 1] = "OnePlex";
    Plexity[Plexity["TwoPlex"] = 2] = "TwoPlex";
})(Plexity || (Plexity = {}));
export var Channel;
(function (Channel) {
    Channel[Channel["Channel1"] = 1] = "Channel1";
    Channel[Channel["Channel2"] = 2] = "Channel2";
})(Channel || (Channel = {}));
export var channelsForPlexity = function (plexity) {
    return Array.from({ length: plexity }, function (_, i) { return (i + 1); });
};
export var adminConfigurations = [
    ProKitConfig.ProbeDetect,
    ProKitConfig.ProbeOnly,
    ProKitConfig.DetectOnly,
    ProKitConfig.StarterKitProbe,
    ProKitConfig.Other,
    ProKitConfig.ExtrasOnly
];
export var consumerConfigurations = [
    ProKitConfig.ProbeDetect,
    ProKitConfig.ProbeOnly,
    ProKitConfig.DetectOnly
];
//# sourceMappingURL=KitDeserializer.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/KitDeserializer.js
// module id = 35
// module chunks = 0